import React, {Fragment} from 'react';
import CouponContent from '../../components/account/CouponContent';

const Coupon = () => {
    return (
        <Fragment>       
            <div className="title_wrap">
                <div className="title_box">
                    <div className="title">쿠폰</div>
                </div>
            </div>
            <CouponContent />
        </Fragment>
    );
};

export default Coupon;


// WEBPACK FOOTER //
// ./src/containers/Account/Coupon.js